// Общие примитивы разбора сырого JSON движка. Отчёт и разбор звонка бэк не
// типизирует — форма проверяется здесь. Приехать может кусок от движка
// постарше (без части полей), поэтому каждое поле имеет фолбэк, а не бросает.

export const isRecord = (v: unknown): v is Record<string, unknown> =>
  typeof v === 'object' && v !== null && !Array.isArray(v)

export const rec = (v: unknown): Record<string, unknown> => (isRecord(v) ? v : {})
export const str = (v: unknown): string => (typeof v === 'string' ? v : '')
export const num = (v: unknown): number => (typeof v === 'number' && Number.isFinite(v) ? v : 0)
export const list = (v: unknown): unknown[] => (Array.isArray(v) ? v : [])
export const bool = (v: unknown): boolean => v === true

// Ненаступившая стадия ключа на проводе не несёт вовсе (omitzero); нулевая
// Go-дата старых движков означает ровно то же — для UI это ''.
export function stamp(v: unknown): string {
  const s = str(v)
  return s.startsWith('0001-01-01') ? '' : s
}

export function between(from: string, to: string): number {
  if (!from || !to) return 0
  const delta = Date.parse(to) - Date.parse(from)
  return Number.isFinite(delta) && delta > 0 ? Math.round(delta) : 0
}

// Фолбэк для кусков без мс-раскладки: считаем стадию по её же таймстемпам.
export const span = (ms: number, from: string, to: string): number =>
  ms > 0 ? ms : between(from, to)

// Положение события на оси звонка (мс от started_at); -1 — оси нет.
export function callTimeMs(startedAt: string, iso: string): number {
  if (!startedAt || !iso) return -1
  const delta = Date.parse(iso) - Date.parse(startedAt)
  return Number.isFinite(delta) && delta >= 0 ? Math.round(delta) : -1
}

// Доля промпта, взятая из prefix-cache: 0..1; без usage — null.
export function cacheShare(cachedTokens: number, promptTokens: number): number | null {
  if (promptTokens <= 0) return null
  return Math.min(1, Math.max(0, cachedTokens / promptTokens))
}
